export default function InvestmentFocus() {
  const focuses = [
    {
      icon: 'ri-building-line',
      title: 'Infrastructure Development',
      description: 'Investment in logistics hubs, industrial parks, transportation infrastructure, and large-scale development projects.'
    },
    {
      icon: 'ri-factory-line',
      title: 'Industrial Production',
      description: 'Capital investment in manufacturing facilities, industrial gas production, and strategic energy infrastructure.'
    },
    {
      icon: 'ri-truck-line',
      title: 'Logistics & Trade Infrastructure',
      description: 'Development of logistics facilities, distribution networks, and global supply chain infrastructure.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Commodities & Trade',
      description: 'Investment in commodity supply chains supporting agriculture, energy, and industrial materials.'
    },
    {
      icon: 'ri-film-line',
      title: 'Media & Entertainment',
      description: 'Strategic investment across film, music, news, and digital media — building global content infrastructure and audience reach.'
    }
  ];

  return (
    <section className="bg-gradient-to-b from-black to-zinc-950 py-16 sm:py-24 lg:py-32">
      <div className="container mx-auto px-4 sm:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-10 sm:mb-16 lg:mb-20">
            <h2 className="text-white text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">INVESTMENT FOCUS</h2>
            <p className="text-yellow-600 text-sm tracking-[0.3em] uppercase font-light">
              Strategic Sectors Driving Global Growth
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 mb-10 sm:mb-16">
            {focuses.map((focus, index) => (
              <div
                key={index}
                className="bg-black border border-yellow-600/30 p-6 sm:p-8 flex flex-col justify-center items-center text-center group hover:border-yellow-600 hover:shadow-[0_0_30px_rgba(214,175,55,0.3)] hover:-translate-y-2 transition-all duration-300 cursor-pointer"
              >
                {/* Icon */}
                <div className="w-14 h-14 sm:w-20 sm:h-20 flex items-center justify-center mb-5 sm:mb-8">
                  <i className={`${focus.icon} text-4xl sm:text-6xl text-yellow-600`}></i>
                </div>

                {/* Title */}
                <h3 className="text-white text-lg sm:text-xl lg:text-2xl font-bold mb-3 sm:mb-4 leading-tight">
                  {focus.title}
                </h3>

                {/* Description */}
                <p className="text-white/70 text-sm font-light leading-relaxed">
                  {focus.description}
                </p>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <div className="text-center">
            <a
              href="#portfolio"
              className="inline-block border border-yellow-600 text-yellow-600 px-8 sm:px-12 py-4 font-semibold tracking-wide hover:bg-yellow-600/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              EXPLORE OPPORTUNITIES
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
